import { Link } from "@mui/material";
import { DotLegalAlert } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";

export interface BulkSelectionAlertProps {
    limitText: string;
    exceedsLimit: boolean;
    selectedCount: number;
    onDeselectAllClick: () => void;
    marginTop: number;
}

/** The selection count above a list in bulk mode, with a way to drop a selection that may span several pages. */
function BulkSelectionAlert(props: BulkSelectionAlertProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalAlert
            severity={props.exceedsLimit ? "error" : "info"}
            warningText={
                <>
                    {props.limitText}
                    {props.selectedCount > 0 && (
                        <>
                            {" "}
                            <Link sx={{ fontWeight: 600 }} component="button" type="button" onClick={props.onDeselectAllClick}>
                                {translateString("deselectAll")}
                            </Link>
                        </>
                    )}
                </>
            }
            marginTop={props.marginTop}
        />
    );
}

export default BulkSelectionAlert;
